import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  Button,
  Box,
  IconButton, TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Formik } from "formik";
import CloseIcon from "@material-ui/icons/CloseRounded";
import DualListSelect from "../../select/dualListSelect";

const useStyles = makeStyles((theme) => ({
  accessBox: {
    display: "flex",
    flexFlow: "column",
  },
  publishButton: {
    color: theme.palette.common.white,
  },
  scrollContainer: {
    maxHeight: "70vh",
    overflowY: "auto",
    backgroundColor: "#f3f3f3",
  },
  dialogPaper: {
    width: '1200px',
    maxWidth: '1200px',
  },
}));

export default function CompanyGroupDialogComponent({
  open,
  selected,
  handleSubmit,
  handleClose,
  isLoading,
  isUpdating,
  allCompany,
}) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll="paper"
      classes={{ paper: classes.dialogPaper }}
    >
      <Formik
        initialValues={{
          name: selected?.name ?? "",
          selected: selected?.items ? selected.items.map((e) => e.uuid) : [],
        }}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <form onSubmit={formik.handleSubmit}>
            <DialogTitle id="scroll-dialog-title">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box flexGrow={1}>
                    <Typography fontSize={16}>
                      Create Company Group
                    </Typography>
                  </Box>
                </Box>

                <IconButton
                  size="small"
                  color="inherit"
                  onClick={handleClose}
                  style={{ padding: 0 }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent style={{ backgroundColor: 'white' }} dividers className={classes.scrollContainer}>
              <Box className={classes.accessBox} mt={2}>
                <TextField
                  fullWidth
                  label="Name"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  variant="outlined"
                />
                <Box my={2}>
                  <DualListSelect
                    list={allCompany.map((item) => item.id)}
                    selectedList={formik.values.selected}
                    nameRef={Object.fromEntries(allCompany.map((item) => [item.id, item.name]))}
                    onChange={(value) => formik.setFieldValue('selected', value)}
                  />
                </Box>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                variant="text"
                type="button"
                disabled={isUpdating}
                onClick={handleClose}
                style={{ color: "black" }}
              >
                Cancel
              </Button>
              <Button variant="contained" type="submit" disabled={isUpdating}>
                Save
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
}
